/**
 * Created by Nomy on 08/08/2017.
 */
"use strict";

class SuperLeadsController {
    constructor($scope, $window, $timeout, $localStorage, SSHttpService, SSUtilService, SSAppService, SSUserService, SSAlertService, SSConfirmationService) {

        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.$storage = $localStorage;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;

        self.leads = null;
        self.properties = null;
        self.units = null;
        self.developers = null;
        self.brokers = null;
        self.agencies = null;
        self.buyers = null;
        self.offset = 0;
        self.limit = 10;

        self.BUYER_ENQUIRY_TYPE_GENERAL = SHOWSUITE.BUYER_ENQUIRY_TYPE_GENERAL;
        self.BUYER_ENQUIRY_TYPE_DEVELOPER = SHOWSUITE.BUYER_ENQUIRY_TYPE_DEVELOPER;
        self.BUYER_ENQUIRY_TYPE_BROKER = SHOWSUITE.BUYER_ENQUIRY_TYPE_BROKER;
        self.BUYER_ENQUIRY_TYPE_THIRD_PARTY = SHOWSUITE.BUYER_ENQUIRY_TYPE_THIRD_PARTY;
        self.BUYER_ENQUIRY_TYPE_INTERNAL = SHOWSUITE.BUYER_ENQUIRY_TYPE_INTERNAL;
        self.BUYER_ENQUIRY_TYPE_BUYER = SHOWSUITE.BUYER_ENQUIRY_TYPE_BUYER;

        self.BUYER_ENQUIRY_STATUS_CREATED = SHOWSUITE.BUYER_ENQUIRY_STATUS_CREATED;
        self.BUYER_ENQUIRY_STATUS_VERIFIED = SHOWSUITE.BUYER_ENQUIRY_STATUS_VERIFIED;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY;
        self.BUYER_ENQUIRY_STATUS_VIEWED = SHOWSUITE.BUYER_ENQUIRY_STATUS_VIEWED;
        self.BUYER_ENQUIRY_STATUS_BOOKED = SHOWSUITE.BUYER_ENQUIRY_STATUS_BOOKED;
        self.BUYER_ENQUIRY_STATUS_APPROVED = SHOWSUITE.BUYER_ENQUIRY_STATUS_APPROVED;
        self.BUYER_ENQUIRY_STATUS_EXERCISED = SHOWSUITE.BUYER_ENQUIRY_STATUS_EXERCISED;
        self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID = SHOWSUITE.BUYER_ENQUIRY_STATUS_COMMISSION_PAID;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

        self.BUYER_ENQUIRY_READ_STATUS_UNREAD = SHOWSUITE.BUYER_ENQUIRY_READ_STATUS_UNREAD;
        self.BUYER_ENQUIRY_READ_STATUS_READ = SHOWSUITE.BUYER_ENQUIRY_READ_STATUS_READ;
        self.BUYER_ENQUIRY_MATCH_STATUS_STRONG = SHOWSUITE.BUYER_ENQUIRY_MATCH_STATUS_STRONG;
        self.BUYER_ENQUIRY_MATCH_STATUS_WEAK = SHOWSUITE.BUYER_ENQUIRY_MATCH_STATUS_WEAK;

        self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
        self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
        self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;
        self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
        self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
        self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
        self.SALE_STATUS_EXERCISED = SHOWSUITE.SALE_STATUS_EXERCISED;
        self.SALE_STATUS_EXPIRED = SHOWSUITE.SALE_STATUS_EXPIRED;
        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
        self.SALE_STATUS_INVALID = SHOWSUITE.SALE_STATUS_INVALID;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
        self.SALE_STATUS_DELETED = SHOWSUITE.SALE_STATUS_DELETED;

        self.initConstants();

        if (!self.SSUserService.getUser()) {
            self.SSUserService.showLoginModal();
            return;
        }

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.getLeads();
        self.getAllProperties();
    }

    getLeads() {
        const self = this;
        self.leads = [];
        let url = 'sec/super/leads';
        let params = {
            offset: self.offset,
            limit: self.limit,
            include: 'properties, units, brokers, agencies, buyers, transfers, buyer_enquiry_matches, buyer_enquiry_history, sales, users',
            property_id: self.searchProjects,
            type: self.searchLeadTypes,
            status: self.searchEnquiryStatuses,
            sale_status: self.sale_status,
            search_text: self.searchText,
            send_total_count: 1,
            order: '{"updated_at":"desc"}'
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            if (response.data.leads) {
                self.leads = response.data.leads;
                self.readLeadsCount = response.data.count;
                self.properties = response.data.properties;
                self.units = response.data.units;
                self.developers = response.data.developers;
                self.brokers = response.data.brokers;
                self.agencies = response.data.agencies;
                self.buyers = response.data.buyers;
                self.sales = response.data.sales;
                self.users = response.data.users;
                if (response.data.transferred_leads) {
                    self.arrangeTransferredLeadIntoLeads(response.data.transferred_leads)
                }

                $.each(self.leads, function(index, lead){
                    if(lead.buyer_enquiry_matches && lead.buyer_enquiry_matches.length > 0 && self.sales.length > 0){
                        // There will be only one sale with 'Approved' status if any
                        $.each(lead.buyer_enquiry_matches, function(idx, match){
                            if(match.approved){
                               let sale = self.sales.find(x => x.id == match.sale_id);
                                if(sale){
                                    lead.sale = sale;
                                } 
                            }
                        });
                    }
                });
            }
        });
    }

    showMoreLeads() {
        const self = this;

        self.limit = self.limit + 10
        self.getLeads();
    }

    onDelete(lead_id){
        const self = this;

        self.hideModal();
        self.delete_lead_id = lead_id;
        self.showModal = true;
        $('#confirmDeleteLeadModal').modal('show');
    }

    onDeleteConfirmation(){
        const self = this;

        self.hideModal();
        let url = 'sec/super/leads/' + parseInt(self.delete_lead_id) + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
              self.SSAlertService.parseAndDisplayError(response);
              return;
            }
            self.SSAlertService.success('Success!', 'Lead deleted successfully');
            // Refresh the page
            self.$window.location.href = '/super/leads';
        });
    }

    hideModal() {
        const self = this;

        self.showModal = false;
        self.showAgentDetailModal = false;
        self.showConversionModal = false;

        if ($('#confirmDeleteLeadModal').is(':visible')) $('#confirmDeleteLeadModal').modal('hide');
        if ($('#agentDetailModal').is(':visible')) $('#agentDetailModal').modal('hide');
        if ($('#conversionModal').is(':visible')) $('#conversionModal').modal('hide');
    }

    getAllProperties() {
        const self = this;

        let url = 'properties/customized';
        let params = {
            property_selected_fields: 'id, name, named_id',
            offset: 0,
            limit: 9999
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.properties) {
                self.projectsOfAllLeads = response.data.properties;
            }

            self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
        });
    }

    filterLeads() {
        const self = this;

        self.offset = 0;
        self.limit = 10;

        self.getLeads();
    }

    getEnquiryStatusName(status) {
        const self = this;

        let found_status = self.enquiry_statuses.find(x => x.id == status);

        if (found_status) {
            return found_status.name;
        }

        return "";
    }

    getStatusClass(status){
        const self = this;

        if(!status){
            return "";
        }

        let found_status = self.enquiry_statuses.find(x => x.id == status);

        if(found_status){
            return found_status.class;
        }

        return "";
    }

    getLeadTypeName(type) {
        const self = this;

        let found_type = self.lead_types.find(x => x.id == type);

        if (found_type) {
            return found_type.name;
        }

        return "";
    }

    displayAgentDetails(broker_id) {
        const self = this;

        self.showAgentObj = self.getBrokerObj(broker_id);
        self.showAgencyObj = self.getAgencyObj(self.showAgentObj.agency_id);

        self.hideModal();

        self.showAgentDetailModal = true;
        $('#agentDetailModal').modal('show');
    }

    getBuyerObj(buyer_id) {
        const self = this;

        if (buyer_id && self.buyers && self.buyers.length > 0) {
            return self.buyers.find(x => x.id == buyer_id);
        }

        return "";
    }

    getUserObj(user_id) {
        const self = this;

        if (user_id && self.users && self.users.length > 0) {
            return self.users.find(x => x.id == user_id);
        }

        return "";
    }

    getPropertyObj(property_id) {
        const self = this;

        if (property_id) {
            return self.properties.find(x => x.id == property_id);
        }

        return "";
    }

    getUnitObj(unit_id) {
        const self = this;

        if (unit_id) {
            return self.units.find(x => x.id == unit_id);
        }

        return "";
    }

    getBrokerObj(broker_id) {
        const self = this;

        if (broker_id) {
            return self.brokers.find(x => x.user_id == broker_id);
        }

        return "";
    }

    getAgencyObj(agency_id) {
        const self = this;

        if (agency_id) {
            return self.agencies.find(x => x.id == agency_id);
        }

        return "";
    }

    onEdit(lead_id) {
        const self = this;

        self.$window.location.href = '/super/leads/edit/' + lead_id;
    }

    onWithdraw(lead_id){
        const self = this;

        self.hideModal();
        self.withdraw_lead_id = lead_id;
        self.showWithdrawModal = true;
        $('#confirmWithdrawLeadModal').modal('show');
    }

    onWithdrawConfirmation(){
        const self = this;

        self.hideModal();
        let url = 'sec/super/leads/' + parseInt(self.withdraw_lead_id) + '/transfer';

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
              self.SSAlertService.parseAndDisplayError(response);
              return;
            }
            self.SSAlertService.success('Success!', 'Lead withdrawn successfully');
            // Refresh the page
            self.$window.location.href = '/super/leads';
        });
    }

    viewHistory(lead){
        const self = this;

        self.leads_history = lead.buyer_enquiry_history;
        self.hideModal();
        $('#leadsHistoryModal').modal('show');
    }

    arrangeTransferredLeadIntoLeads(transferred_leads) {
        const self = this;

        $.each(transferred_leads, function(index, transferred_lead) {
            let found_lead = self.leads.find(x => x.id == transferred_lead.buyer_enquiry_id);

            if (found_lead) {
                found_lead.transferred_lead = transferred_lead;
            }
        });
    }

    onConversion(lead) {
        const self = this;

        self.conversionObj = lead;

        if (self.conversionObj.buyer_enquiry_matches) {
            $.each(self.conversionObj.buyer_enquiry_matches, function(index, buyer_enquiry) {
                let sale_obj = {};
                let sale_creator = {};
                if (buyer_enquiry.sale_id) {
                    sale_obj = self.sales.find(x => x.id == buyer_enquiry.sale_id);
                    
                    if (sale_obj.created_by) {
                        sale_creator = self.users.find(x => x.id == sale_obj.created_by);
                    }
                }

                sale_obj['sale_creator'] = sale_creator;
                buyer_enquiry['sale'] = sale_obj;
            });
            self.hideModal();
            self.showConversionModal = true;
            $('#conversionModal').modal('show');
        } else {
            self.SSAlertService.danger("Error!", "No conversion found in this lead, please contact administrator.");
        }
    }

    getBuyerEnquiryStatus(status) {
        const self = this;

        if (status) {
            let enquiry_status = self.buyer_enquiry_statuses.find(x => x.id == status);

            if (enquiry_status) {
                return enquiry_status.name;
            }
        }

        return "";
    }

    getSaleStatus(status) {
        const self = this;

        if (status) {
            let sale_status = self.sale_statuses.find(x => x.id == status);

            if (sale_status) {
                return sale_status.name;
            }
        }

        return "";
    }

    approveEnquiryMatch(buyer_enquiry) {
        const self = this;

        self.hideModal();
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to approve this match?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/super/leads/' + parseInt(self.conversionObj.id) + '/approve';
                let param = {
                    buyer_enquiry_match_id: buyer_enquiry.id
                }

                loading(true);
                self.SSHttpService.postAPIRequest(url, param).then(function (response) {
                    loading(false);
                    self.hideModal();
                    if (response instanceof Error) {
                      self.SSAlertService.parseAndDisplayError(response);
                      return;
                    }
                    self.SSAlertService.success('Success!', 'Buyer Enquiry approved successfully.');
                    // Refresh the page
                    self.$window.location.href = '/super/leads';
                });
        });
    }

    getStatusName(statuses, id){
        const self = this

        let name = '--';
        if(!(statuses && id)){
            return name;
        }

        let status = statuses.find(x => x.id == id);
        if(status){
            name = status.name;
        }

        return name;
    }

    getUserName(id){
        const self = this

        let name = '--';
        if(!id){
            return name;
        }

        let user = self.users.find(x => x.id == id);
        if(user){
            name = user.display_name? user.display_name : user.first_name +" "+ user.last_name ;
        }

        return name;
    }

    getOTP(id){
        const self = this

        let otp_no = '--';
        if(!id){
            return otp_no;
        }

        let sale = self.sales.find(x => x.id == id);
        if(sale){
            otp_no = sale.otp_no;
        }

        return otp_no;
    }

    initConstants(){
        const self = this;

        self.lead_types = [
            {id: self.BUYER_ENQUIRY_TYPE_GENERAL, name: "Organic"},
            {id: self.BUYER_ENQUIRY_TYPE_DEVELOPER, name: "Developer"},
            {id: self.BUYER_ENQUIRY_TYPE_BROKER, name: "Broker"},
            {id: self.BUYER_ENQUIRY_TYPE_THIRD_PARTY, name: "Third Party"},
            {id: self.BUYER_ENQUIRY_TYPE_INTERNAL, name: "Internal"},
            {id: self.BUYER_ENQUIRY_TYPE_BUYER, name: "Referrals"},
        ];

        self.enquiry_statuses = [
            {id: self.BUYER_ENQUIRY_STATUS_CREATED, name: "Created", class: "text-primary"},
            {id: self.BUYER_ENQUIRY_STATUS_VERIFIED, name: "Verified"},
            {id: self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY, name: "Sent to Team IC", class: "text-warning"},
            {id: self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT, name: "Assigned to Agent", class: "text-warning"},
            {id: self.BUYER_ENQUIRY_STATUS_VIEWED, name: "Viewed by Agent", class: "text-warning"},
            {id: self.BUYER_ENQUIRY_STATUS_BOOKED, name: "Booking Submitted"},
            {id: self.BUYER_ENQUIRY_STATUS_APPROVED, name: "Approved Conversion", class: "text-success"},
            {id: self.BUYER_ENQUIRY_STATUS_EXERCISED, name: "Sale Exercised", class: "text-success"},
            {id: self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID, name: "Commission Paid", class: "text-success"},
        ];

        self.buyer_enquiry_statuses = [
            {id: self.BUYER_ENQUIRY_MATCH_STATUS_STRONG, name: "Strong"},
            {id: self.BUYER_ENQUIRY_MATCH_STATUS_WEAK, name: "Weak"},
        ];

        self.sale_statuses = [
            {id: self.SALE_STATUS_DRAFT, name: "Draft"},
            {id: self.SALE_STATUS_PENDING, name: "Pending Buyer Signing"},
            {id: self.SALE_STATUS_SUBMITTED, name: "Submitted"},
            {id: self.SALE_STATUS_VERIFIED, name: "Verified"},
            {id: self.SALE_STATUS_APPROVED, name: "Approved"},
            {id: self.SALE_STATUS_REJECTED, name: "Rejected"},
            {id: self.SALE_STATUS_OTP, name: "OTP"},
            {id: self.SALE_STATUS_CHEQUE_ENTERED, name: "Cheque Entered"},
            {id: self.SALE_STATUS_SPA_ENTERED, name: "SPA Entered"},
            {id: self.SALE_STATUS_EXTENDED, name: "Extended"},
            {id: self.SALE_STATUS_EXERCISED, name: "Exercised"},
            {id: self.SALE_STATUS_EXPIRED, name: "Expired"},
            {id: self.SALE_STATUS_ABORTED, name: "Aborted"},
            {id: self.SALE_STATUS_INVALID, name: "Invalid"},
            {id: self.SALE_STATUS_DONE, name: "Done"},
            {id: self.SALE_STATUS_DELETED, name: "Deleted"},
        ];

        self.selective_sale_statuses = [
            {id: self.SALE_STATUS_PENDING, name: "Pending Buyer Signing"},
            {id: self.SALE_STATUS_REJECTED, name: "Rejected"},
            {id: self.SALE_STATUS_OTP, name: "OTP"},
            {id: self.SALE_STATUS_SPA_ENTERED, name: "SPA Entered"},
            {id: self.SALE_STATUS_ABORTED, name: "Aborted"},
        ];

    }

    canPerformAction(lead_type) {
        const self = this;

        if (lead_type == self.BUYER_ENQUIRY_TYPE_THIRD_PARTY || lead_type == self.BUYER_ENQUIRY_TYPE_INTERNAL || lead_type == self.BUYER_ENQUIRY_TYPE_BUYER || lead_type == self.BUYER_ENQUIRY_TYPE_GENERAL) {
            return true;
        }

        return false;
    }

    canEdit(lead_status) {
        const self = this;

        switch (lead_status) {
            case self.BUYER_ENQUIRY_STATUS_CREATED:
            case self.BUYER_ENQUIRY_STATUS_VERIFIED:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY:
            case self.BUYER_ENQUIRY_STATUS_VIEWED:
            case self.BUYER_ENQUIRY_STATUS_BOOKED:
            case self.BUYER_ENQUIRY_STATUS_APPROVED:
            case self.BUYER_ENQUIRY_STATUS_EXERCISED:
                return true;

            case self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID:
                return false;

            default:
                return false;
        }
    }

    canDelete(lead_status) {
        const self = this;

        switch (lead_status) {
            case self.BUYER_ENQUIRY_STATUS_CREATED:
            case self.BUYER_ENQUIRY_STATUS_VERIFIED:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY:
            case self.BUYER_ENQUIRY_STATUS_VIEWED:
                return true;

            case self.BUYER_ENQUIRY_STATUS_BOOKED:
            case self.BUYER_ENQUIRY_STATUS_APPROVED:
            case self.BUYER_ENQUIRY_STATUS_EXERCISED:
            case self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID:
                return false;

            default:
                return false;
        }
    }

    canConverse(lead_status) {
        const self = this;

        switch (lead_status) {
            case self.BUYER_ENQUIRY_STATUS_CREATED:
            case self.BUYER_ENQUIRY_STATUS_VERIFIED:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY:
            case self.BUYER_ENQUIRY_STATUS_VIEWED:
            case self.BUYER_ENQUIRY_STATUS_BOOKED:
            case self.BUYER_ENQUIRY_STATUS_APPROVED:
                return true;

            case self.BUYER_ENQUIRY_STATUS_EXERCISED:
            case self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID:
                return false;

            default:
                return false;
        }
    }

    canTransfer(lead_status) {
        const self = this;

        switch (lead_status) {
            case self.BUYER_ENQUIRY_STATUS_CREATED:
            case self.BUYER_ENQUIRY_STATUS_VERIFIED:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY:
            case self.BUYER_ENQUIRY_STATUS_VIEWED:
                return true;

            case self.BUYER_ENQUIRY_STATUS_BOOKED:
            case self.BUYER_ENQUIRY_STATUS_APPROVED:
            case self.BUYER_ENQUIRY_STATUS_EXERCISED:
            case self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID:
                return false;

            default:
                return false;
        }
    }

    canWithdraw(lead_status) {
        const self = this;

        switch (lead_status) {
            case self.BUYER_ENQUIRY_STATUS_CREATED:
            case self.BUYER_ENQUIRY_STATUS_VERIFIED:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT:
            case self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY:
            case self.BUYER_ENQUIRY_STATUS_VIEWED:
                return true;

            case self.BUYER_ENQUIRY_STATUS_BOOKED:
            case self.BUYER_ENQUIRY_STATUS_APPROVED:
            case self.BUYER_ENQUIRY_STATUS_EXERCISED:
            case self.BUYER_ENQUIRY_STATUS_COMMISSION_PAID:
                return false;

            default:
                return false;
        }
    }

    toggleLeadMessageSection(lead) {
        let div = $('#notification-message-lead-' + lead.id);

        if (lead.display_message_section) {
            div.slideUp(400);
        } else {
            div.slideDown(400);
        }

        lead.display_message_section = !lead.display_message_section;
    }
    
}

SuperLeadsController.$inject = ['$scope', '$window', '$timeout', '$localStorage', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSAlertService', 'SSConfirmationService'];
app.controller('SuperLeadsController', SuperLeadsController);

